import { useResponsiveReady } from '../../hooks/use-responive-ready';

const OnlyMobile = ({ children }) => {
  const { isMobile } = useResponsiveReady();

  return isMobile ? children : null;
};

export default OnlyMobile;
